import React from "react";
import {Columns, Heading, Modal, Section, Form} from "react-bulma-components";
import LoadingSpinner from "../../Utils/Spinner";
import {readableDate} from "../../../utils";


export default function RentalInfoModal({data, loaded, open, setOpen}){

    if(!loaded){
        return (
            <Modal
                show={open}
                closeOnBlur
                onClose={() => setOpen(false)}
            >
                <Modal.Content>
                    <Section style={{background: "white"}}>
                        <LoadingSpinner/>
                    </Section>
                </Modal.Content>
            </Modal>
        )
    }

    return (
        <Modal
            show={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Rental Info</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Hire Type</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={data.rental_type}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>On Hire Date</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={readableDate(data.on_hire_date)}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Chargeable Date</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={readableDate(data.chargeable_date)}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Vehicle</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={data.vehicle ? data.vehicle.registration : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Customer</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={data.customer ? data.customer.display_name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Payer</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={data.payer ? data.payer.display_name : ""}
                            />
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}